<mbs-table-grid
  [data]="licenses() || []"
  [entityName]="'shared:captions.licenses' | i18next: { format: 'title' }"
  [headers]="headers"
  [loading]="loading()"
  [maxHeight]="tableMaxHeight()"
  [minHeight]="'50px'">
  <ng-template
    let-license
    mbsTableCell>
    {{ license.detail }}
  </ng-template>

  <ng-template
    let-license
    mbsTableCell>
    {{ (license.periodStart | date: 'mediumDate') + ' - ' + (license.periodEnd | date: 'mediumDate') }}
  </ng-template>

  <ng-template
    let-license
    mbsTableCell>
    {{ (license.unitCost | pricePrepayment: null : '1.2-8' | async) + ' ' + license.unitCostDetail }}
  </ng-template>

  <ng-template
    let-license
    mbsTableCell>
    {{ license.quantity }}
  </ng-template>

  <ng-template
    let-license
    mbsTableCell>
    {{ license.total | pricePrepayment | async }}
  </ng-template>
</mbs-table-grid>

@if (total()) {
  <b
    *ngIf="total"
    class="text-end w-100 d-block mt-3">
    Total {{ total() | pricePrepayment | async }}
  </b>
}
